<template>
  <div
    v-if="appReady"
    id="app"
    :class="{'disable-mouse': isMouseDisabled}">
    <youpaired-header />
    <div class="app-router-container">
      <router-view/>
    </div>
    <youpaired-footer />
    <cookie-banner />
    <portal-target name="dialogs"/>
    <portal-target name="dropdowns"/>
    <welcome-dialog v-if="false"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import YoupairedHeader from '@/components/YoupairedHeader.vue';
import WelcomeDialog from '@/components/WelcomeDialog.vue';
import YoupairedFooter from '@/components/YoupairedFooter.vue';
import CookieBanner from '@/components/CookieBanner.vue';

export default {
  name: 'App',
  components: {
    YoupairedHeader,
    WelcomeDialog,
    YoupairedFooter,
    CookieBanner,
  },
  data() {
    return {
      appReady: false,
    };
  },
  computed: {
    ...mapState('utils', ['isMouseDisabled']),
  },
  methods: {
    ...mapActions('auth', ['trySetUser']),
  },
  async created() {
    await this.trySetUser();
    this.appReady = true;
  },
};

</script>
<style lang="scss">
@import '@/assets/youpaired-colors.scss';
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');

#app {
  font-family: 'Source Sans Pro', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-size: 0.875rem;
}

body {
  background-color: $body-background;
  margin: 0;
}

.app-router-container {
  padding-top: 4rem;
  min-height: 80vh;
}

textarea:focus, input:focus, select:focus, button:focus {
  outline: none;
}

// /**
//  * Tooltip Styles
//  */

// /* Base styles for the element that has a tooltip */
// [data-tooltip],
// .tooltip {
//   position: relative;
//   cursor: pointer;
// }

// /* Base styles for the entire tooltip */
// [data-tooltip]:before,
// [data-tooltip]:after,
// .tooltip:before,
// .tooltip:after {
//   position: absolute;
//   visibility: hidden;
//   -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
//   filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
//   opacity: 0;
//   -webkit-transition:
//       opacity 0.2s ease-in-out,
//         visibility 0.2s ease-in-out,
//         -webkit-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
//     -moz-transition:
//         opacity 0.2s ease-in-out,
//         visibility 0.2s ease-in-out,
//         -moz-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
//     transition:
//         opacity 0.2s ease-in-out,
//         visibility 0.2s ease-in-out,
//         transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
//   -webkit-transform: translate3d(0, 0, 0);
//   -moz-transform:    translate3d(0, 0, 0);
//   transform:         translate3d(0, 0, 0);
//   pointer-events: none;
// }

// /* Show the entire tooltip on hover and focus */
// [data-tooltip]:hover:before,
// [data-tooltip]:hover:after,
// [data-tooltip]:focus:before,
// [data-tooltip]:focus:after,
// .tooltip:hover:before,
// .tooltip:hover:after,
// .tooltip:focus:before,
// .tooltip:focus:after {
//   visibility: visible;
//   -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
//   filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
//   opacity: 1;
// }

// /* Base styles for the tooltip's directional arrow */
// .tooltip:before,
// [data-tooltip]:before {
//   z-index: 1001;
//   border: 6px solid transparent;
//   background: transparent;
//   content: "";
// }

// /* Base styles for the tooltip's content area */
// .tooltip:after,
// [data-tooltip]:after {
//   z-index: 1000;
//   padding: 8px;
//   width: 130px;
//   background-color: #000;
//   background-color: hsla(0, 0%, 20%, 0.9);
//   color: #fff;
//   content: attr(data-tooltip);
//   font-size: 14px;
//   line-height: 1.2;
// }

// /* Directions */

// /* Top (default) */
// [data-tooltip]:before,
// [data-tooltip]:after,
// .tooltip:before,
// .tooltip:after,
// .tooltip-top:before,
// .tooltip-top:after {
//   bottom: 100%;
//   left: 50%;
// }

// [data-tooltip]:before,
// .tooltip:before,
// .tooltip-top:before {
//   margin-left: -6px;
//   margin-bottom: -12px;
//   border-top-color: #000;
//   border-top-color: hsla(0, 0%, 20%, 0.9);
// }

// /* Horizontally align top/bottom tooltips */
// [data-tooltip]:after,
// .tooltip:after,
// .tooltip-top:after {
//   margin-left: -80px;
// }

// [data-tooltip]:hover:before,
// [data-tooltip]:hover:after,
// [data-tooltip]:focus:before,
// [data-tooltip]:focus:after,
// .tooltip:hover:before,
// .tooltip:hover:after,
// .tooltip:focus:before,
// .tooltip:focus:after,
// .tooltip-top:hover:before,
// .tooltip-top:hover:after,
// .tooltip-top:focus:before,
// .tooltip-top:focus:after {
//   -webkit-transform: translateY(-12px);
//   -moz-transform:    translateY(-12px);
//   transform:         translateY(-12px);
// }

// /* Left */
// .tooltip-left:before,
// .tooltip-left:after {
//   right: 100%;
//   bottom: 50%;
//   left: auto;
// }

// .tooltip-left:before {
//   margin-left: 0;
//   margin-right: -12px;
//   margin-bottom: 0;
//   border-top-color: transparent;
//   border-left-color: #000;
//   border-left-color: hsla(0, 0%, 20%, 0.9);
// }

// .tooltip-left:hover:before,
// .tooltip-left:hover:after,
// .tooltip-left:focus:before,
// .tooltip-left:focus:after {
//   -webkit-transform: translateX(-12px);
//   -moz-transform:    translateX(-12px);
//   transform:         translateX(-12px);
// }

// /* Bottom */
// .tooltip-bottom:before,
// .tooltip-bottom:after {
//   top: 100%;
//   bottom: auto;
//   left: 50%;
// }

// .tooltip-bottom:before {
//   margin-top: -12px;
//   margin-bottom: 0;
//   border-top-color: transparent;
//   border-bottom-color: #000;
//   border-bottom-color: hsla(0, 0%, 20%, 0.9);
// }

// .tooltip-bottom:hover:before,
// .tooltip-bottom:hover:after,
// .tooltip-bottom:focus:before,
// .tooltip-bottom:focus:after {
//   -webkit-transform: translateY(12px);
//   -moz-transform:    translateY(12px);
//   transform:         translateY(12px);
// }

// /* Right */
// .tooltip-right:before,
// .tooltip-right:after {
//   bottom: 50%;
//   left: 100%;
// }

// .tooltip-right:before {
//   margin-bottom: 0;
//   margin-left: -12px;
//   border-top-color: transparent;
//   border-right-color: #000;
//   border-right-color: hsla(0, 0%, 20%, 0.9);
// }

// .tooltip-right:hover:before,
// .tooltip-right:hover:after,
// .tooltip-right:focus:before,
// .tooltip-right:focus:after {
//   -webkit-transform: translateX(12px);
//   -moz-transform:    translateX(12px);
//   transform:         translateX(12px);
// }

// /* Move directional arrows down a bit for left/right tooltips */
// .tooltip-left:before,
// .tooltip-right:before {
//   top: 3px;
// }

// /* Vertically center tooltip content for left/right tooltips */
// .tooltip-left:after,
// .tooltip-right:after {
//   margin-left: 0;
//   margin-bottom: -16px;
// }

// video wrapper
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
  z-index: 5;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}


// edit form styles

.edit-form, .edit-form-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: left;
  margin: 0 auto;
  letter-spacing: .5px;
  font-size: 0.875rem;
  color: #444444;
  width: 100%;
}

.edit-form-margin-top {
  margin: 0.5rem auto 0 auto;
}

.edit-form label, .package-header-note {
  width: 100%;
  text-align: left;
  padding: 0.5rem 0;
  font-weight: 500;
  font-size: 1rem;
}

.package-header-note {
  margin-bottom: 1rem;
  line-height: 2rem;
  border-bottom: 0.5px solid lightgray;
  text-align: justify;
}

.edit-form input {
  width: 100%;
  text-align: left;
  height: 2rem;
  border: 1px solid #DCDBDB;
  font-size: 0.875rem;
  color: #444444;
}

.edit-form textarea {
  // WTF hack
  font-family: 'Source Sans Pro', 'Helvetica Neue', sans-serif;
  width: 100%;
  text-align: left;
  height: auto;
  font-size: 0.875rem;
  font-weight: normal;
  color: #484848;
  border: 1px solid #DCDBDB;
  border-radius: 0.1rem;
  text-indent: 0;
  font-size: 0.875rem;
  color: #444444;
}

.edit-form .button {
  cursor: pointer;
  padding: 0 1rem;
  border-radius: 0.2rem;
  color: #fff;
  background-color: $login-background;
  font-size: 1rem;
  border: 1px solid $login-background;
  font-weight: 800;
  white-space: nowrap;
  letter-spacing: .10em;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
  position: fixed;
  right: 2rem;
  bottom: 1rem;
  height: 2.5rem;
  z-index: 25;
   &:hover{
    background-color: $login-hover;
    border:none;
  }
}

.edit-form .cancel {
  color: $login-background;
  background-color: #fff;
  font-size: 1rem;
  border-color: #fff;
}

.remaining-characters {
  width: 100%;
  text-align: right;
  font-size: 0.75rem;
}

.add-link-button {
  color: #365899;
  cursor: pointer;
  margin: 0.5rem 0;
  text-decoration: none;
  padding: 0.25rem;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  background-color: transparent;
  &:hover {
    text-decoration: underline;
  }
  text-align: left;
  width: 100%;
}

.add-link-button[disabled=disabled] {
  color: grey;
  cursor: default;
  text-decoration: none;
}

.disable-mouse {
  pointer-events: none;
}

</style>
